module.exports = __webpack_public_path__ + "img/winter_greevil_treat.904cbbb9.png";